import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FallbackTextDirective, TiimeLargePropertyDirective, TiimePropertyDirective } from 'tiime-material';

@Component({
  selector: 'app-company-permanent-note-properties',
  standalone: true,
  imports: [TiimeLargePropertyDirective, TiimePropertyDirective, FallbackTextDirective],
  templateUrl: './company-permanent-note-properties.component.html',
  styleUrls: ['./company-permanent-note-properties.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyPermanentNotePropertiesComponent {
  @Input() title = 'Note dossier :';
  @Input() permanentNote: string;
}
